<template>
    <TaxonomyTemplate
        taxonomy-term="tags"
        :taxonomy-page="taxonomyPage"
        :show-pills="showPills"
        :post-list-heading="postListHeading"
    />
</template>

<router>
{
    meta: {
        hideGettingStartedProgressBar: true
    }
}
</router>

<script>
import taxonomyMixin from '~/mixins/taxonomyMixin';
import TaxonomyTemplate from '~/components/magazine/TaxonomyTemplate.vue';

export default {
    name: 'MagazineTagPage',
    components: {
        TaxonomyTemplate,
    },
    mixins: [taxonomyMixin],
    layout: 'magazine',
    async asyncData(context) {
        // First argument sets 'this' context for the method, subsequent arguments are passed as arguments to the method
        return await taxonomyMixin.methods.getTaxonomyData.call(context, context, 'tags');
    },
    computed: {
        postListHeading() {
            return this.$t('magazine.tag.post_list_heading', {
                tag: this.taxonomyPage?.taxonomySettings?.header_title,
            });
        },
    },
    nuxtI18n: {
        paths: {
            se: '/magasin/tag/:slug?',
            'fi-sv': '/magasin/tag/:slug?',
            en: '/magazine/tag/:slug?',
            de: '/magazin/tag/:slug?',
            at: '/magazin/tag/:slug?',
            fi: '/lehti/tag/:slug?',
            no: '/magasin/tag/:slug?',
            dk: '/magasin/tag/:slug?',
            ch: '/magazin/tag/:slug?',
            fr: '/magazine/tag/:slug?',
        },
    },
};
</script>
